import styled from 'styled-components';

export const Container = styled.div`
  flex-grow: 1;
  overflow: auto;

  button {
    margin-top: 30px;
    margin-left: 5px;
  }
`;

export const Input = {
  width: '300px',
};
